module.exports = __webpack_public_path__ + "cb4c2756d22af55657daf31ef01f8af4.MP3";